import React from "react";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Body from "@/ui/Body";
import Title from "@/ui/Title";
import Image from "@/ui/Image";
import Button from "../../components/Button";

export const TextandImage = ({ className, title, content, image, buttons }) => {
  const defaultButtons = [
    {
      name: "Give Now",
      animation: true,
      href: "https://www.justgiving.com/campaign/xcede",
      newTab: false,
      variant: "primary",
      className: "mt-4 ml-4",
    },
  ];

  const btnArray = Array.isArray(buttons) && buttons.length ? buttons : defaultButtons;
  return (
    <div className={clsx(className, classes.ceo)}>
      <div className={classes.left_section}>
        {image ? <Image className={classes.charitybot} img={image.url} size="720x405" alt={image.title} /> : ""}
      </div>

      <div className={classes.right_section}>
        <Title
          title={title}
          containerClass="highlight-titles-"
          className="highlight font-weight-light size-h2 quaternary"
          tag="h2"
          highlight={true}
          hideBr={true}
        />

        <Body className={classes.body} body={content} />

        <div className={classes.button_row}>
          {btnArray.map((btn, idx) => (
            <Button
              key={idx}
              display={btn.name}
              animation={btn.animation}
              link={btn.href}
              newTab={btn.newTab}
              className={clsx(
                "font-regular",
                "ml-10",
                "mt-4",
                btn.variant ? `btn-${btn.variant}` : "btn-primary",
                btn.className,
                classes.button_item,
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TextandImage;
